import { render, staticRenderFns } from "./MaterialForm.vue?vue&type=template&id=d705883c&scoped=true&"
import script from "./MaterialForm.vue?vue&type=script&lang=js&"
export * from "./MaterialForm.vue?vue&type=script&lang=js&"
import style0 from "./MaterialForm.vue?vue&type=style&index=0&id=d705883c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d705883c",
  null
  
)

export default component.exports